import React from 'react';
import PropTypes from 'prop-types';

import Player from './Player';
import PositionFilter from './PositionFilter';

import '../css/player-grids.css';
import '../css/display-type.css';

const Draft = props => (
  <div className="draft">
    <div id="draft-bucket" className="bucket">
      <div className="bucket__header">
        <h5>The draft</h5>
        <p>The Patriots have nine picks in the 2021 draft. The next dynasty could be one choice away. Which of these players would you take with the No. 15 pick in the first round? Make it count, you only get one.</p>
        <PositionFilter 
          filterPositions={props.filterPositions}
          filterKey='positionFilterDraft'
        />
      </div>
      <div id="draft-pool" className="player-grid">
        {Object.keys(props.draftGroup).map((key) => {
          if (props.draftGroup[key].type === "draft" 
              && (
                props.draftGroup[key].position === props.positionFilterDraft 
                || props.positionFilterDraft === ''
                )
              ) {
              return <Player 
                key={key}
                index={key}
                alterTeam={props.alterTeam}
                details={props.draftGroup[key]}
                drafted={props.drafted} 
              />
            } return null;
          }
          )}
      </div>
    </div>
  </div>
)

Draft.propTypes = {
  draftGroup: PropTypes.object,
  alterTeam: PropTypes.func,
  drafted: PropTypes.string,
  filterPositions: PropTypes.func,
  positionFilterDraft: PropTypes.string,
}

export default Draft;